import { ButtonHTMLAttributes, FC, ReactNode } from 'react';
import Button from './Button';

interface GradientBorderButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  children: ReactNode;
  size?: 'sm' | 'md' | 'lg';
  className?: string;
}

/**
 * Gradient Border Button Component
 *
 * A specialized button component that applies the gradient border design
 * used throughout the site. This encapsulates the specific styling while
 * maintaining all the functionality of the base Button component.
 */
const GradientBorderButton: FC<GradientBorderButtonProps> = ({
  children,
  size = 'md',
  className = '',
  ...props
}) => {
  return (
    <Button variant="outline" size={size} className={`btn-gradient-border ${className}`} {...props}>
      {children}
    </Button>
  );
};

export default GradientBorderButton;
